import { createTheme } from '@mui/material/styles';
import { baseComponents } from './components';
import { osirisTokens } from './tokens';
import './muiAugmentation';

export const darkTheme = createTheme({
  osiris: osirisTokens,
  typography: {
    fontFamily: osirisTokens.fonts.body,
    allVariants: {
      fontFamily: osirisTokens.fonts.body,
    },
    h1: { fontFamily: osirisTokens.fonts.display, letterSpacing: '0.06em' },
    h2: { fontFamily: osirisTokens.fonts.display, letterSpacing: '0.06em' },
    h3: { fontFamily: osirisTokens.fonts.display, letterSpacing: '0.06em' },
    h4: { fontFamily: osirisTokens.fonts.display, letterSpacing: '0.04em' },
    h5: { fontFamily: osirisTokens.fonts.display, letterSpacing: '0.04em' },
    h6: { fontFamily: osirisTokens.fonts.display, letterSpacing: '0.04em' },
    overline: {
      fontFamily: osirisTokens.fonts.mono,
      fontWeight: 500,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: osirisTokens.accent.main,
      light: osirisTokens.accent.mid,
      dark: '#5733d0',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9198a1',
    },
    background: {
      default: osirisTokens.bg.page,
      paper: osirisTokens.bg.page,
    },
    text: {
      primary: osirisTokens.text.primary,
      secondary: osirisTokens.text.secondary,
      disabled: osirisTokens.text.muted,
    },
    divider: osirisTokens.border.primary,
    error: {
      main: osirisTokens.text.error,
      light: osirisTokens.icons.error,
      dark: '#b8442f',
      contrastText: '#ffffff',
    },
    warning: {
      main: osirisTokens.text.warning,
      light: '#ffd84d',
      dark: '#cca300',
      contrastText: '#1a1a1a',
    },
    success: {
      main: osirisTokens.text.success,
      light: '#94d89a',
      dark: '#4b9d53',
      contrastText: '#ffffff',
    },
    info: {
      main: osirisTokens.accent.mid,
      light: '#a08cff',
      dark: osirisTokens.accent.main,
      contrastText: '#ffffff',
    },
    grey: {
      50: '#f0f6fc',
      100: '#c6a19f',
      200: '#9198a1',
      300: '#656c76',
      400: '#3d444d',
      500: '#2f3742',
      600: '#262c36',
      700: '#212830',
      800: '#151b23',
      900: '#0d1117',
      A100: '#c6a19f',
      A200: '#9198a1',
      A400: '#656c76',
      A700: '#3d444d',
    },
  },
  components: baseComponents,
});
